/* template */
<template minapp="mpx" xlang="wxml"><from-item :isShow="(isShow)" :isRequired="(isRequired)" :isRequiredShow="(isRequiredShow)" label="国家地区" :innerValue="(country_name_cn)" :isDisable="(isNationlityDisable)" class="item-style"><div slot="input" class="es-content__birth-data-input"><mpx-view @tap="goSelectCountry" class="es-content__nationality"><div v-if="(country_name_cn)">{{country_name_cn || ''}}</div><div class="placeholder" v-else>请选择</div></mpx-view><es-icon name="angle-right" size="16" color="#999999" @click="goSelectCountry"></es-icon></div></from-item></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0674eb8f"}'>
  .item-style
    margin-bottom 16px
  +b('content')
    +e('birth-data-input')
      display flex
      width 100%
      justify-content space-between
      align-items center
    +e('nationality')
      width 100%
      height 100%
      min-height 50px
      line-height 50px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0674eb8f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./nationlity12306.mpx.js?isComponent&outputPath=components%2Fnationlity123060674eb8f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./nationlity12306.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fnationlity123060674eb8f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0674eb8f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/nationlity123060674eb8f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
